import { render } from "./AggregateChart.vue?vue&type=template&id=5726ecf7"
import script from "./AggregateChart.vue?vue&type=script&lang=js"
export * from "./AggregateChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__